export const REGISTRADO = 1;
export const EN_PROCESO = 2;
export const CERRADO = 3;
export const ANULADO = 4;